import { jwtDecode } from 'jwt-decode'

/**
 * Decodes the payload of a JWT without verification (client-side only).
 * The token is already trusted when obtained via getSessionToken().
 */
export type SessionTokenPayload = {
  sub: string
  email_hash?: string
  graftcode_uid?: string
  [key: string]: unknown
}

export function decodeJwtPayload(token: string): SessionTokenPayload | null {
  try {
    const payload = jwtDecode<SessionTokenPayload>(token)
    return typeof payload.sub === 'string' ? payload : null
  } catch {
    return null
  }
}
